import { FC } from 'react'
import classes from '../index.module.css'

type Props = {
  label: string
  value: string
}

const ActiveFilter = ({ label, value }: Props) => {
  return (
    <div className={classes.activeFilter}>
      <span className={classes.label}>{label}:</span>
      <span>{value}</span>
    </div>
  )
}

export default ActiveFilter
